export default __webpack_public_path__ + "static/media/watch.b46ca97f.csv";